import React from 'react'

interface HomeProps {
  isSelected?: boolean
}

export const HomeIcon: React.FC<HomeProps> = ({ isSelected = false }) => {
  const stroke = isSelected ? '#FF4A8E' : '#62718D'
  const className = isSelected ? 'dark:stroke-[#FF4A8E]' : 'dark:stroke-gray-400'

  return (
    <svg width="20" height="20" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.22221 11.4999H1L10.9999 1.5L20.9999 11.4999H18.7777"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
      />
      <path
        d="M3.22266 11.5V19.2777C3.22266 19.8671 3.45678 20.4323 3.87353 20.8491C4.29027 21.2658 4.8555 21.4999 5.44486 21.4999H16.5559C17.1453 21.4999 17.7105 21.2658 18.1272 20.8491C18.544 20.4323 18.7781 19.8671 18.7781 19.2777V11.5"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
      />
      <path
        d="M7.66602 21.5002V14.8335C7.66602 14.2442 7.90014 13.6789 8.31689 13.2622C8.73363 12.8455 9.29886 12.6113 9.88822 12.6113H12.1104C12.6998 12.6113 13.265 12.8455 13.6818 13.2622C14.0985 13.6789 14.3326 14.2442 14.3326 14.8335V21.5002"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
      />
    </svg>
  )
}

export default HomeIcon
